<template>
  <div>
    <el-card class="box-card">
      <el-row :gutter="50" class="mb-1">
        <el-col :span="9" class="adv-image-box">
          <img
            src="@/apps/traforama/assets/images/referrals/money-up.png"
            class="invite-img"
          />
        </el-col>
        <el-col :span="15">
          <div class="invitation">
            <span class="msg-1"> Invite advertisers to join us </span>
            <span class="msg-2">
              earn a 5 % of the income
              <br />
              generated by the referred
              <br />
              advertisers
            </span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <el-row class="mb-1">
        <el-col :span="24" class="shares-container">
          <div class="link-box">
            <ReferralLink :domain="domain" />
            <el-row class="mt-1 btn-row">
              <el-button class="kit-btn" type="primary" round>
                <a href="/Traforama_referral.pdf" target="_blank"
                  >Download Media Kit</a
                >
              </el-button>
              <div class="advice">
                We recommend you sending the media kit to the referred
                advertisers,
                <br />
                as it will make his experience easier with us.
              </div>
            </el-row>
          </div>
          <div class="earnings">
            <div class="name">Your Earnings:</div>
            <div class="amount">${{ referralAdvert }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <h2>how it works</h2>
      <div class="steps-container">
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-1a.png" />
          <div class="big-text">
            You copy & share the referral link with Advertisers
          </div>
        </div>
        <img
          src="@/apps/traforama/assets/icons/arrow-right.png"
          class="right-arrow"
        />
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-2a.png" />
          <div class="big-text">
            Advertisers register on Traforama and buy traffic
          </div>
        </div>
        <img
          src="@/apps/traforama/assets/icons/arrow-right.png"
          class="right-arrow"
        />
        <div class="step">
          <img src="@/apps/traforama/assets/images/referrals/step-3a.png" />
          <div class="big-text">
            You start earning 5% from the profit generated by the Advertisers
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useUserStore } from '@/store/modules/user'
import ReferralLink from './ReferralLink.vue'

export default defineComponent({
  name: 'AdvertReferrals',
  components: {
    ReferralLink
  },
  setup(_props, _context) {
    const userStore = useUserStore()
    const domain = 'traforama'

    const referralAdvert = computed(() => {
      return userStore.referralAdvert
    })

    return { domain, referralAdvert }
  }
})
</script>
